import Tarif from "../containers/Tarifs/Tarifs";

const TarifPage = () => {
  return <Tarif />;
};

export default TarifPage;
